import { Formik } from 'formik'

import { useCreateMedia } from 'src/hooks'
import { ICreateMediaForm } from 'src/types'
import { mediaCreateSchema } from 'src/common/validations'

import { MediaCreateForm } from './form.component'

interface IProps {
  handleClose: () => void
}

export const ModalInner = ({ handleClose }: IProps) => {
  const { mutateAsync: createMedia } = useCreateMedia()

  const handleSubmit = async (values: ICreateMediaForm) => {
    await createMedia(values)
    handleClose()
  }

  return (
    <Formik
      onSubmit={handleSubmit}
      validationSchema={mediaCreateSchema}
      validateOnMount
      initialValues={{ media: [] }}
    >
      <MediaCreateForm />
    </Formik>
  )
}
